(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soera-careers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-soc-role]');
    if (!link) return;
    var root = link.closest('.so-careers');
    if (!root) return;
    var select = root.querySelector('select[name="contact[role]"]');
    if (select) select.value = link.dataset.socRole;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soera-withdrawal"]) return;
  try {
    
document.querySelectorAll('[data-soera-withdrawal]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const copy = JSON.parse(root.querySelector('[data-sw-copy]').textContent);
  const form = root.querySelector('form'), review = root.querySelector('.sw-review'), success = root.querySelector('.sw-success');
  const confirm = root.querySelector('[data-confirm]'), edit = root.querySelector('[data-edit]'), error = root.querySelector('.sw-error');
  let data, receipt, submissionId, lastFingerprint, submitting = false;
  const fill = (target, rows) => {
    target.replaceChildren();
    rows.forEach(([label, value]) => { const dt = document.createElement('dt'), dd = document.createElement('dd'); dt.textContent = label; dd.textContent = value; target.append(dt, dd); });
  };
  const rows = () => [[copy.name, data.name], [copy.email, data.email], [copy.contract, data.contract], [copy.items, data.items || copy.entire]];
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    const fields = new FormData(form);
    data = { name: fields.get('name').trim(), email: fields.get('email').trim(), contract: fields.get('contract').trim(), items: fields.get('items').trim(), website: fields.get('website'), confirmed: true };
    const fingerprintBytes = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(data)));
    const fingerprint = Array.from(new Uint8Array(fingerprintBytes), byte => byte.toString(16).padStart(2, '0')).join('');
    try {
      const saved = JSON.parse(sessionStorage.getItem('soera-withdrawal-submission') || 'null');
      submissionId = saved && saved.fingerprint === fingerprint ? saved.id : (lastFingerprint === fingerprint && submissionId ? submissionId : crypto.randomUUID());
      sessionStorage.setItem('soera-withdrawal-submission', JSON.stringify({ fingerprint, id: submissionId }));
    } catch (storageError) {
      if (lastFingerprint !== fingerprint || !submissionId) submissionId = crypto.randomUUID();
    }
    lastFingerprint = fingerprint;
    fill(root.querySelector('[data-review-details]'), rows());
    form.hidden = true; review.hidden = false; error.hidden = true;
    root.querySelector('[data-step-two]').classList.add('sw-active');
    review.querySelector('h2').focus();
  });
  edit.addEventListener('click', () => {
    if (submitting) return;
    review.hidden = true; form.hidden = false; error.hidden = true;
    root.querySelector('[data-step-two]').classList.remove('sw-active');
    form.querySelector('input').focus();
  });
  confirm.addEventListener('click', async () => {
    if (submitting) return;
    submitting = true; confirm.disabled = true; edit.disabled = true; confirm.textContent = copy.sending; error.hidden = true;
    try {
      const response = await fetch(root.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...data, submission_id: submissionId }), signal: AbortSignal.timeout(45000) });
      const result = await response.json();
      if (!response.ok || result.status !== 'received' || !result.reference || !result.received_at) throw new Error(result.error || copy.error);
      receipt = result;
      fill(root.querySelector('[data-receipt-details]'), [...rows(), [copy.reference, receipt.reference], [copy.received, receipt.received_at]]);
      root.querySelector('[data-success-message]').textContent = (receipt.email_status === 'needs_review' ? copy.uncertain : copy.success).replace('[email]', data.email);
      review.hidden = true; success.hidden = false; success.querySelector('h2').focus();
    } catch (failure) {
      error.textContent = copy.error;
      error.hidden = false;
    } finally {
      submitting = false; confirm.disabled = false; edit.disabled = false; confirm.textContent = copy.confirm;
    }
  });
  root.querySelector('[data-download]').addEventListener('click', () => {
    if (!receipt) return;
    const text = 'SOERA\n\n' + copy.notice + '\n\n' + [...rows(), [copy.reference, receipt.reference], [copy.received, receipt.received_at]].map(([label, value]) => label + ': ' + value).join('\n') + '\n\nsupport@soera-store.com\n';
    const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
    const link = document.createElement('a'); link.href = url; link.download = 'SOERA-withdrawal-' + receipt.reference + '.txt'; link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
  });
});

  } catch(e) { console.error(e); }
})();
})();
